<component :is='internalTemplate'></component>